/* src/app/shared/library/ddtopnav/ddtopnav.component.scss */
.dd-top-nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  z-index: 1000;
  height: 4rem;
  margin: 0.5rem 0.7rem;
  overflow: hidden;
  border-radius: 0.74rem;
  background: var(--surface-a);
}
.dd-top-nav-container .topnav-left {
  display: flex;
  align-items: center;
  padding-left: 1rem;
  background: var(--surface-a);
  flex: 1;
  position: relative;
  height: 100%;
}
.dd-top-nav-container .topnav-left .topnav-logo-container {
  display: flex;
  align-items: center;
  z-index: 1;
  height: 100%;
}
.dd-top-nav-container .topnav-left .topnav-logo-container .ddlogo {
  display: inline-flex;
  align-items: center;
}
.dd-top-nav-container .topnav-left .topnav-logo-container .ddlogo img {
  height: 2rem;
}
.dd-top-nav-container .topnav-left .topnav-logo-container .ddlogo span {
  font-size: 1.2rem;
  font-weight: 600;
  margin-left: 0.5rem;
  color: #0e3c4c;
}
.dd-top-nav-container .topnav-left .topnav-links-container {
  margin-left: 5rem;
  display: inline-flex;
  align-self: center;
  z-index: 1;
  height: 100%;
}
.dd-top-nav-container .topnav-left::after {
  content: "";
  display: block;
  width: 3rem;
  height: 100%;
  position: absolute;
  background: var(--surface-a);
  z-index: 2;
  right: 14rem;
  transform-origin: bottom;
  transform: skewX(30deg);
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
}
.dd-top-nav-container .topnav-right {
  flex: 1;
  display: inline-flex;
  height: 100%;
  padding-right: 1rem;
  margin-left: -16.5rem;
  overflow: hidden;
  align-items: center;
  background: var(--secondary-500);
  position: relative;
}
/*# sourceMappingURL=ddtopnav.component.css.map */
